module.exports = __webpack_public_path__ + "static/media/1021853.86784488.jpg";